import {
    FerryMedium,
    LondonDlrColourMedium,
    LondonOvergroundColourMedium,
    LondonUndergroundColourMedium,
    NationalRailColourMedium
} from '@zoopla-eng/zds/icons';
import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    transportLinkIconWrapperStyle,
    transportLinkRowItemStyle,
    transportLinkRowListStyle,
    transportLinkTextStyle
} from './transport-links.styles.css';

type TransportLinkProps = {
    transports?:
        | ({
              title?: string | null;
              poiType?: string | null;
              distanceInMiles?: number | null;
          } | null)[]
        | null;
};

const TransportLinkIcon: React.FC<{ transportType?: string | null }> = ({
    transportType
}) => {
    switch (transportType) {
        case 'london_underground_station':
            return <LondonUndergroundColourMedium />;
        case 'national_rail_station':
            return <NationalRailColourMedium />;
        case 'uk_ferry_port':
            return <FerryMedium />;
        case 'london_dlr_station':
            return <LondonDlrColourMedium />;
        case 'london_overground_station':
            return <LondonOvergroundColourMedium />;
        default:
            return null;
    }
};

const TransportLinks: React.FC<TransportLinkProps> = ({ transports }) => {
    return transports && transports?.length > 0 ? (
        <ul className={transportLinkRowListStyle}>
            {transports?.map((transport) => {
                if (!transport) {
                    return null;
                }

                const { poiType, distanceInMiles, title } = transport;

                return (
                    <li
                        className={`${transportLinkRowItemStyle} ${fontGroups.fork}`}
                        key={`${poiType}-${distanceInMiles}-${title}`}
                    >
                        <div className={transportLinkIconWrapperStyle}>
                            <TransportLinkIcon transportType={poiType} />
                        </div>
                        <span
                            className={transportLinkTextStyle}
                        >{`${distanceInMiles} mile${
                            distanceInMiles === 1 ? '' : 's'
                        } ${title}`}</span>
                    </li>
                );
            })}
        </ul>
    ) : null;
};

export { TransportLinks };
